import { useState } from 'react';
import { INTEGRATIONS_CATALOG } from './mockData';
import { WindexSchoolCodeForm } from './WindexSchoolCodeForm';

import whatsappIcon from '../../assets/WhatsApp_icon.png';
import instagramIcon from '../../assets/Instagram_icon.png';
import facebookIcon from '../../assets/Facebook_icon.png';
import threadsIcon from '../../assets/Threads_icon.png';
import windexIcon from '../../assets/Windex_icon.jpg';

// Reusable SVG logo components for a beautiful, premium visual representation
export const IntegrationLogo = ({ type, size = 'h-12 w-12' }) => {
  switch (type) {
    case 'whatsapp':
      return (
        <div className={`${size} flex items-center justify-center shrink-0`}>
          <img
            src={whatsappIcon}
            alt="WhatsApp"
            className="w-full h-full object-contain"
          />
        </div>
      );
    case 'tiktok':
      return (
        <div
          className={`${size} rounded-2xl bg-black border border-white/10 flex items-center justify-center shrink-0 shadow-lg`}
        >
          <svg
            className="w-1/2 h-1/2 text-text-primary"
            viewBox="0 0 24 24"
            fill="currentColor"
          >
            <path d="M12.525.02c1.31-.03 2.61-.01 3.91-.02.08 1.53.63 3.09 1.75 4.17 1.12 1.11 2.7 1.62 4.24 1.79v4.03c-1.44-.17-2.86-.74-3.99-1.72-.08-.07-.15-.15-.22-.23v6.49c0 1.87-.55 3.73-1.63 5.2-1.07 1.48-2.67 2.56-4.44 2.96-1.78.4-3.69.18-5.32-.61-1.64-.8-2.97-2.22-3.69-3.92-.72-1.7-.75-3.65-.08-5.37.66-1.72 2-3.14 3.69-3.93 1.42-.67 3-.84 4.53-.5v4.09c-.93-.24-1.95-.14-2.8.31-.85.45-1.51 1.25-1.8 2.19-.3.94-.21 2 .25 2.86.46.85 1.28 1.47 2.22 1.69.94.22 1.95.04 2.76-.48.81-.53 1.34-1.44 1.44-2.42.03-.31.04-.63.04-.94V.02z" />
          </svg>
        </div>
      );
    case 'instagram':
      return (
        <div className={`${size} flex items-center justify-center shrink-0`}>
          <img
            src={instagramIcon}
            alt="Instagram"
            className="w-full h-full object-contain"
          />
        </div>
      );
    case 'apple':
      return (
        <div
          className={`${size} rounded-2xl bg-slate-900 border border-slate-700 flex items-center justify-center text-slate-100 shrink-0 shadow-lg`}
        >
          <svg className="w-1/2 h-1/2" viewBox="0 0 24 24" fill="currentColor">
            <path d="M18.71 19.5c-.83 1.24-1.71 2.45-3.05 2.47-1.34.03-1.77-.79-3.29-.79-1.53 0-2 .77-3.27.82-1.31.05-2.3-1.32-3.14-2.53C4.25 17 2.94 12.45 4.7 9.39c.87-1.52 2.43-2.48 4.12-2.51 1.28-.02 2.5.87 3.29.87.78 0 2.26-1.07 3.81-.91.65.03 2.47.26 3.64 1.98-.09.06-2.17 1.28-2.15 3.81.03 3.02 2.65 4.03 2.68 4.04-.03.07-.42 1.44-1.38 2.83M15.97 4.17c.66-.81 1.11-1.93.99-3.06-1 .04-2.2.67-2.92 1.51-.62.73-1.16 1.87-1.02 2.98 1.1.09 2.22-.53 2.95-1.43z" />
          </svg>
        </div>
      );
    case 'viber':
      return (
        <div
          className={`${size} rounded-2xl bg-[#7360f2] flex items-center justify-center text-text-primary shrink-0 shadow-lg shadow-[#7360f2]/20`}
        >
          <svg className="w-1/2 h-1/2" viewBox="0 0 24 24" fill="currentColor">
            <path d="M19.78 17.51a5.61 5.61 0 0 1-1.12.87c-.52.28-1 .44-1.49.49a21.46 21.46 0 0 1-4.8-.4c-1-.24-1.89-.57-2.73-1a13.38 13.38 0 0 1-4.14-3.8 12.44 12.44 0 0 1-2.09-3.9 15.65 15.65 0 0 1-.6-3.86v-.27a3.54 3.54 0 0 1 1-2.49 3.06 3.06 0 0 1 2.21-.92c.31 0 .61.08.88.24s.5.39.69.7L9 6.85a2.29 2.29 0 0 1 .37.89c.07.31.06.63-.05.93a5.55 5.55 0 0 1-.68 1.2 5 5 0 0 0 1.2 1.58 4.73 4.73 0 0 0 1.83 1.07l.22-.26a4.89 4.89 0 0 1 .84-1c.29-.26.62-.42 1-.49a2.29 2.29 0 0 1 1.4.24l2.79 1.62c.35.2.61.47.78.8s.25.7.25 1.08c-.02.4-.11.8-.27 1.2z" />
          </svg>
        </div>
      );
    case 'facebook':
      return (
        <div className={`${size} flex items-center justify-center shrink-0`}>
          <img
            src={facebookIcon}
            alt="Facebook"
            className="w-full h-full object-contain"
          />
        </div>
      );
    case 'telegram':
      return (
        <div
          className={`${size} rounded-2xl bg-[#229ED9] flex items-center justify-center text-text-primary shrink-0 shadow-lg shadow-[#229ED9]/20`}
        >
          <svg className="w-1/2 h-1/2" viewBox="0 0 24 24" fill="currentColor">
            <path
              d="M12 24c6.627 0 12-5.373 12-12S18.627 0 12 0 0 5.373 0 12s5.373 12 12 12z"
              fill="currentColor"
              opacity="0.1"
            />
            <path d="M18.35 6.03a.53.53 0 0 0-.57-.05l-14 5.5a.5.5 0 0 0-.03.92l3.75 1.17 1.25 3.9a.5.5 0 0 0 .86.15l2.4-2.05 4.3 3.15a.5.5 0 0 0 .8-.35l3-12a.5.5 0 0 0-.3-.45zM8.5 13.5l6-3.8-4.5 4.2-1.5-.4z" />
          </svg>
        </div>
      );
    case 'wechat':
      return (
        <div
          className={`${size} rounded-2xl bg-[#09B83E] flex items-center justify-center text-text-primary shrink-0 shadow-lg shadow-[#09B83E]/20`}
        >
          <svg className="w-1/2 h-1/2" viewBox="0 0 24 24" fill="currentColor">
            <path d="M8.5 14c4.14 0 7.5-2.91 7.5-6.5S12.64 1 8.5 1 1 3.91 1 7.5S4.36 14 8.5 14zm-4-8.5c.55 0 1 .45 1 1s-.45 1-1 1-1-.45-1-1 .45-1 1-1zm6 0c.55 0 1 .45 1 1s-.45 1-1 1-1-.45-1-1 .45-1 1-1zm10 8.5c0-3.04-2.91-5.5-6.5-5.5-.34 0-.68.03-1 .08A6.87 6.87 0 0 1 14 12c0 3.59-3.36 6.5-7.5 6.5-.45 0-.9-.05-1.33-.13L3.5 19.5a.5.5 0 0 0-.15.85l2.5-1.45c.81.22 1.68.35 2.58.35 4.14 0 7.5-2.91 7.5-6.5s-3.36-6.5-7.5-6.5zm-5 2c.41 0 .75.34.75.75s-.34.75-.75.75-.75-.34-.75-.75.34-.75.75-.75zm4 0c.41 0 .75.34.75.75s-.34.75-.75.75-.75-.34-.75-.75.34-.75.75-.75z" />
          </svg>
        </div>
      );
    case 'windex':
      return (
        <div className={`${size} flex items-center justify-center shrink-0`}>
          <img
            src={windexIcon}
            alt="Windex"
            className="w-full h-full object-contain"
          />
        </div>
      );
    case 'threads':
      return (
        <div className={`${size} flex items-center justify-center shrink-0`}>
          <img
            src={threadsIcon}
            alt="Threads"
            className="w-full h-full object-contain"
          />
        </div>
      );
    case 'wazzup':
      return (
        <div
          className={`${size} rounded-2xl bg-[#06302B] border border-[#0d594f] flex items-center justify-center shrink-0 shadow-lg shadow-[#06302B]/20`}
        >
          <div className="flex gap-1 items-center justify-center text-emerald-400">
            <svg className="w-6 h-6" viewBox="0 0 24 24" fill="currentColor">
              <path d="M12 2C6.48 2 2 6.48 2 12s4.48 10 10 10 10-4.48 10-10S17.52 2 12 2zm1 .75v1.5c0 .41-.34.75-.75.75h-1.5c-.41 0-.75-.34-.75-.75v-1.5c0-.41.34-.75.75-.75h1.5c.41 0 .75.34.75.75zm-6.25 4c0-.41.34-.75.75-.75h1.5c.41 0 .75.34.75.75v1.5c0 .41-.34.75-.75.75h-1.5c-.41 0-.75-.34-.75-.75v-1.5zm11.5 0v1.5c0 .41-.34.75-.75.75h-1.5c-.41 0-.75-.34-.75-.75v-1.5c0-.41.34-.75.75-.75h1.5c.41 0 .75.34.75.75zM12 9c1.66 0 3 1.34 3 3s-1.34 3-3 3-3-1.34-3-3 1.34-3 3-3z" />
            </svg>
          </div>
        </div>
      );
    case 'chatapp':
      return (
        <div
          className={`${size} rounded-2xl bg-[#02443a] border border-[#086a5b] flex items-center justify-center shrink-0 shadow-lg`}
        >
          <div className="text-emerald-300 font-bold font-sf-pro-display text-base">
            ch@t
          </div>
        </div>
      );
    case 'teletype':
      return (
        <div
          className={`${size} rounded-2xl bg-[#0747a6] flex items-center justify-center text-text-primary shrink-0 shadow-lg shadow-[#0747a6]/20`}
        >
          <svg className="w-1/2 h-1/2" viewBox="0 0 24 24" fill="currentColor">
            <path d="M20 2H4c-1.1 0-2 .9-2 2v18l4-4h14c1.1 0 2-.9 2-2V4c0-1.1-.9-2-2-2zM9 11H7V9h2v2zm4 0h-2V9h2v2zm4 0h-2V9h2v2z" />
          </svg>
        </div>
      );
    case 'radist':
      return (
        <div
          className={`${size} rounded-2xl bg-gradient-to-br from-amber-600 to-orange-700 flex items-center justify-center text-text-primary shrink-0 shadow-lg`}
        >
          <div className="text-xs font-bold uppercase tracking-wider font-sf-pro-display">
            Radist
          </div>
        </div>
      );
    case 'chatarchitect':
      return (
        <div
          className={`${size} rounded-2xl bg-[#11311b] border border-[#2b6d41] flex items-center justify-center shrink-0 shadow-lg`}
        >
          <svg
            className="w-1/2 h-1/2 text-emerald-400"
            viewBox="0 0 24 24"
            fill="none"
            stroke="currentColor"
            strokeWidth="2.5"
            strokeLinecap="round"
            strokeLinejoin="round"
          >
            <rect x="3" y="11" width="18" height="10" rx="2" />
            <circle cx="12" cy="5" r="2" />
            <path d="M12 7v4M8 15h.01M16 15h.01" />
          </svg>
        </div>
      );
    case 'messagehelp':
      return (
        <div
          className={`${size} rounded-2xl bg-[#3b82f6] flex items-center justify-center text-text-primary shrink-0 shadow-lg relative`}
        >
          <span className="text-xs font-bold font-sf-pro-display">Help</span>
          <span className="absolute -top-1 -right-1 h-5 w-5 bg-red-500 rounded-full border-2 border-layer-4-content text-[10px] font-bold flex items-center justify-center">
            1
          </span>
        </div>
      );
    case 'gupshup':
      return (
        <div
          className={`${size} rounded-2xl bg-[#491654] border border-[#762b87] flex items-center justify-center text-purple-200 shrink-0 shadow-lg`}
        >
          <div className="text-[10px] font-bold uppercase tracking-wider">
            Gupshup
          </div>
        </div>
      );
    case 'viber-tele-wa':
      return (
        <div
          className={`${size} rounded-2xl bg-gradient-to-r from-purple-800 via-sky-800 to-emerald-900 flex items-center justify-center text-text-primary shrink-0 shadow-lg`}
        >
          <div className="flex gap-0.5 items-center justify-center scale-90">
            <span className="h-2 w-2 rounded-full bg-purple-400"></span>
            <span className="h-2 w-2 rounded-full bg-sky-400"></span>
            <span className="h-2 w-2 rounded-full bg-emerald-400"></span>
          </div>
        </div>
      );
    case 'chatondesk':
      return (
        <div
          className={`${size} rounded-2xl bg-[#cf4a17] flex items-center justify-center text-text-primary shrink-0 shadow-lg shadow-[#cf4a17]/20`}
        >
          <svg
            className="w-1/2 h-1/2"
            viewBox="0 0 24 24"
            fill="none"
            stroke="currentColor"
            strokeWidth="2.5"
          >
            <path d="M4 19.5v-15A2.5 2.5 0 0 1 6.5 2H20v20H6.5a2.5 2.5 0 0 1-2.5-2.5z" />
            <path d="M6 6h10M6 10h10" />
          </svg>
        </div>
      );
    case 'fromni':
      return (
        <div
          className={`${size} rounded-2xl bg-[#090b1c] border border-indigo-900 flex items-center justify-center shrink-0 shadow-lg`}
        >
          <div className="flex -space-x-1.5">
            <div className="w-4 h-4 rounded-full bg-indigo-500 opacity-80"></div>
            <div className="w-4 h-4 rounded-full bg-purple-500 opacity-80"></div>
          </div>
        </div>
      );
    case 'anylinga':
      return (
        <div
          className={`${size} rounded-2xl bg-[#fcd34d] flex items-center justify-center text-[#451a03] shrink-0 shadow-lg shadow-[#fcd34d]/20`}
        >
          <svg className="w-1/2 h-1/2" viewBox="0 0 24 24" fill="currentColor">
            <circle
              cx="9"
              cy="12"
              r="6"
              fill="none"
              stroke="currentColor"
              strokeWidth="2.5"
            />
            <circle
              cx="15"
              cy="12"
              r="6"
              fill="none"
              stroke="currentColor"
              strokeWidth="2.5"
            />
          </svg>
        </div>
      );
    // General SaaS apps for Active Subscriptions listing
    case 'vercel':
      return (
        <div
          className={`${size} rounded-2xl bg-black border border-border-default flex items-center justify-center text-text-primary shrink-0 shadow-md`}
        >
          <svg className="w-5 h-5 fill-current" viewBox="0 0 24 24">
            <path d="M24 22.525H0L12 1.475L24 22.525Z" />
          </svg>
        </div>
      );
    case 'discord':
      return (
        <div
          className={`${size} rounded-2xl bg-[#5865F2] flex items-center justify-center text-text-primary shrink-0 shadow-md`}
        >
          <svg className="w-5 h-5 fill-current" viewBox="0 0 127.14 96.36">
            <path d="M107.7,8.07A105.15,105.15,0,0,0,77.26,0a77.19,77.19,0,0,0-3.3,6.83A96.67,96.67,0,0,0,53.22,6.83,77.19,77.19,0,0,0,49.88,0,105.15,105.15,0,0,0,19.44,8.07C3.66,31.58-1.86,54.65,1,77.53A105.73,105.73,0,0,0,32,96.36a77.7,77.7,0,0,0,6.63-10.85,68.43,68.43,0,0,1-10.5-5c.88-.65,1.72-1.34,2.51-2a75.58,75.58,0,0,0,73.08,0c.79.71,1.63,1.4,2.51,2a68.43,68.43,0,0,1-10.5,5A77.7,77.7,0,0,0,95.14,96.36a105.73,105.73,0,0,0,31-18.83C129.82,50.12,123.7,27.31,107.7,8.07ZM42.45,65.69C36.18,65.69,31,60,31,53S36.18,40.36,42.45,40.36,53.9,46,53.9,53,48.72,65.69,42.45,65.69Zm42.24,0C78.41,65.69,73.24,60,73.24,53S78.41,40.36,84.69,40.36,96.13,46,96.13,53,91,65.69,84.69,65.69Z" />
          </svg>
        </div>
      );
    case 'notion':
      return (
        <div
          className={`${size} rounded-2xl bg-white border border-slate-200 flex items-center justify-center text-black shrink-0 shadow-md`}
        >
          <span className="text-xl font-bold font-serif leading-none">N</span>
        </div>
      );
    case 'linear':
      return (
        <div
          className={`${size} rounded-2xl bg-gradient-to-tr from-fuchsia-600 via-pink-600 to-orange-600 flex items-center justify-center text-text-primary shrink-0 shadow-md`}
        >
          <svg className="w-5 h-5 fill-current" viewBox="0 0 24 24">
            <path d="M12 2C6.48 2 2 6.48 2 12s4.48 10 10 10 10-4.48 10-10S17.52 2 12 2zm1 17h-2v-2h2v2zm2.07-7.75l-.9.92C13.45 12.9 13 13.5 13 15h-2v-.5c0-1.1.45-2.1 1.17-2.83l1.24-1.26c.37-.36.59-.86.59-1.41 0-1.1-.9-2-2-2s-2 .9-2 2H7c0-2.76 2.24-5 5-5s5 2.24 5 5c0 1.04-.42 1.99-1.07 2.75z" />
          </svg>
        </div>
      );
    case 'adobe':
      return (
        <div
          className={`${size} rounded-2xl bg-[#FF0000] flex items-center justify-center text-text-primary shrink-0 shadow-md`}
        >
          <span className="text-lg font-bold font-sf-pro-display leading-none tracking-tighter">
            A
          </span>
        </div>
      );
    case 'google_workspace':
      return (
        <div className={`${size} flex items-center justify-center shrink-0`}>
          <svg viewBox="0 0 24 24" className="w-full h-full">
            <path
              fill="#4285F4"
              d="M22.56 12.25c0-.78-.07-1.53-.2-2.25H12v4.26h5.92c-.26 1.37-1.04 2.53-2.21 3.31v2.77h3.57c2.08-1.92 3.28-4.74 3.28-8.09z"
            />
            <path
              fill="#34A853"
              d="M12 23c2.97 0 5.46-.98 7.28-2.66l-3.57-2.77c-.98.66-2.23 1.06-3.71 1.06-2.86 0-5.29-1.93-6.16-4.53H2.18v2.84C3.99 20.53 7.7 23 12 23z"
            />
            <path
              fill="#FBBC05"
              d="M5.84 14.09c-.22-.66-.35-1.36-.35-2.09s.13-1.43.35-2.09V7.07H2.18C1.43 8.55 1 10.22 1 12s.43 3.45 1.18 4.93l3.66-2.84z"
            />
            <path
              fill="#EA4335"
              d="M12 5.38c1.62 0 3.06.56 4.21 1.64l3.15-3.15C17.45 2.09 14.97 1 12 1 7.7 1 3.99 3.47 2.18 7.07l3.66 2.84c.87-2.6 3.3-4.53 6.16-4.53z"
            />
          </svg>
        </div>
      );
    case 'other_email':
      return (
        <div
          className={`${size} rounded-2xl bg-gradient-to-br from-indigo-500 to-blue-600 flex items-center justify-center text-white shrink-0 shadow-md shadow-blue-500/20`}
        >
          <svg
            className="w-1/2 h-1/2"
            viewBox="0 0 24 24"
            fill="none"
            stroke="currentColor"
            strokeWidth="2"
            strokeLinecap="round"
            strokeLinejoin="round"
          >
            <rect width="20" height="16" x="2" y="4" rx="2" />
            <path d="m22 7-8.97 5.7a1.94 1.94 0 0 1-2.06 0L2 7" />
          </svg>
        </div>
      );
    default:
      return (
        <div
          className={`${size} rounded-2xl bg-layer-6-elevated border border-border-default flex items-center justify-center text-text-muted shrink-0`}
        >
          <svg
            className="w-1/2 h-1/2"
            fill="none"
            viewBox="0 0 24 24"
            stroke="currentColor"
            strokeWidth="2"
          >
            <path
              strokeLinecap="round"
              strokeLinejoin="round"
              d="M19 11H5m14 0a2 2 0 012 2v6a2 2 0 01-2 2H5a2 2 0 01-2-2v-6a2 2 0 012-2m14 0V9a2 2 0 00-2-2M5 11V9a2 2 0 012-2m0 0V5a2 2 0 012-2h6a2 2 0 012 2v2M7 7h10"
            />
          </svg>
        </div>
      );
  }
};

import { getHealthBadgeInfo } from './integrationHealthUtils';

export default function IntegrationsGrid({
  onSelectApp,
  onConnectInstagram,
  installedApps = {},
  integrationNames = {},
  healthMap = {},
  companyIntegrations = [],
  extraApps = [],
  catalogSlugs = [],
  companyId,
}) {
  const [windexOpen, setWindexOpen] = useState(false);
  const offered = new Set(catalogSlugs);
  const inCatalog = (app) => {
    if (app.id === 'facebook' || app.id === 'threads') return false;
    const slug = app.id === 'whatsapp-business' ? 'whatsapp' : app.id;
    return offered.has(slug);
  };
  const allApps = [
    ...INTEGRATIONS_CATALOG.messengers.filter((app) =>
      ['whatsapp-business', 'instagram', 'facebook', 'threads'].includes(
        app.id,
      ),
    ),
    ...INTEGRATIONS_CATALOG.providers,
    ...extraApps,
  ].filter(inCatalog);

  const formatAppItem = (app) => ({
    ...app,
    name: integrationNames[app.id] || app.name,
    installed:
      app.id === 'windex'
        ? !!app.installed
        : !!installedApps[app.id] || !!healthMap[app.id],
  });

  const apps = allApps.map(formatAppItem);
  const isWhatsAppApp = (app) => app.id === 'whatsapp-business';
  const isInstagramApp = (app) => app.id === 'instagram';
  const isGoogleWorkspaceApp = (app) => app.id === 'google_workspace';
  const isOtherEmailApp = (app) => app.id === 'other_email';

  return (
    <div className="flex flex-col gap-8 pb-8">
      <div className="grid grid-cols-1 sm:grid-cols-2 md:grid-cols-3 lg:grid-cols-4 gap-5">
        {apps.map((app) => {
          const isWhatsApp = isWhatsAppApp(app);
          const isInstagram = isInstagramApp(app);
          const isGoogleWorkspace = isGoogleWorkspaceApp(app);
          const isWindex = app.id === 'windex';
          const isOtherEmail = isOtherEmailApp(app);
          const isAvailableApp =
            isWhatsApp ||
            isInstagram ||
            isGoogleWorkspace ||
            isOtherEmail ||
            isWindex;
          const selectApp = () =>
            isWindex ? setWindexOpen(true) : onSelectApp(app);

          const healthItem = isWindex ? null : healthMap[app.id];
          const hasHealthData = !!healthItem;

          const badgeInfo =
            app.installed && hasHealthData
              ? getHealthBadgeInfo(
                  healthItem?.health_status,
                  healthItem?.health_status_label,
                  app.installed,
                )
              : null;

          const isUnhealthy =
            app.installed && hasHealthData && !badgeInfo?.isHealthy;
          const showStatusBadge = true;

          const companyApp = companyIntegrations.find(
            (i) =>
              i.integration_slug === app.id ||
              (isWhatsApp && i.integration_slug === 'whatsapp'),
          );

          let connectedDetail = healthItem?.connected_account_name;
          if (!connectedDetail && companyApp?.config) {
            if (isWhatsApp) connectedDetail = companyApp.config.mobile_number;
            else if (isGoogleWorkspace || isOtherEmail)
              connectedDetail =
                companyApp.config.email || companyApp.config.account_email;
            else if (isInstagram)
              connectedDetail =
                companyApp.config.username || companyApp.config.handle;
            else if (app.id === 'facebook')
              connectedDetail =
                companyApp.config.page_name || companyApp.config.name;
            else if (app.id === 'threads')
              connectedDetail = companyApp.config.username;
            else if (isWindex && companyApp.is_connected)
              connectedDetail = companyApp.config.school_code;
          }

          return (
            <div
              key={app.id}
              className={`relative p-5 rounded-2xl border bg-white flex flex-col justify-between transition-all duration-300 hover:-translate-y-1 hover:shadow-xl ${
                isUnhealthy
                  ? 'border-rose-300 shadow-md shadow-rose-500/5'
                  : app.installed
                    ? 'border-[#4CAF50] shadow-lg shadow-[#4CAF50]/10'
                    : 'border-gray-200 hover:border-gray-300 shadow-sm'
              }`}
            >
              <div>
                <div className="flex justify-between items-start mb-4">
                  <IntegrationLogo type={app.logoType} size="h-11 w-11" />

                  {showStatusBadge && (
                    <div className="flex flex-col items-end gap-1">
                      {badgeInfo ? (
                        <div
                          className={`flex items-center gap-1.5 px-2.5 py-1 rounded-full text-[10px] font-bold tracking-wide border ${badgeInfo.className}`}
                        >
                          <div
                            className={`w-1.5 h-1.5 rounded-full ${badgeInfo.dotColor}`}
                          />
                          <span>{badgeInfo.label}</span>
                        </div>
                      ) : (
                        <div
                          className={`flex items-center gap-1.5 px-2.5 py-1 rounded-full text-[10px] font-bold tracking-wide ${
                            app.installed
                              ? 'bg-[#E8F5E9] text-[#4CAF50]'
                              : isAvailableApp
                                ? 'bg-blue-50 text-blue-600'
                                : 'bg-blue-50 text-blue-500'
                          }`}
                        >
                          <div
                            className={`w-1.5 h-1.5 rounded-full ${
                              app.installed
                                ? 'bg-[#4CAF50]'
                                : isAvailableApp
                                  ? 'bg-blue-600'
                                  : 'bg-blue-500'
                            }`}
                          />
                          {app.installed
                            ? 'Installed'
                            : isAvailableApp
                              ? 'Available'
                              : 'Coming Soon'}
                        </div>
                      )}

                      {/* Show failure reason under badge when unhealthy */}
                      {isUnhealthy && healthItem?.failure_reason && (
                        <span
                          className="text-[10px] text-rose-600 font-medium text-right max-w-[150px] truncate leading-tight"
                          title={healthItem.failure_reason}
                        >
                          {healthItem.failure_reason}
                        </span>
                      )}
                    </div>
                  )}
                </div>

                <h3
                  className={`text-[17px] font-semibold mb-2 tracking-tight ${
                    isUnhealthy
                      ? 'text-rose-700'
                      : app.installed
                        ? 'text-[#4CAF50]'
                        : 'text-gray-900'
                  }`}
                >
                  {app.name}
                </h3>
                <p className="text-[13px] text-gray-500 leading-relaxed font-medium">
                  {app.description}
                </p>
              </div>

              {isWindex && windexOpen ? (
                <WindexSchoolCodeForm
                  companyId={companyId}
                  initialCode={
                    companyApp?.is_connected
                      ? companyApp?.config?.school_code || ''
                      : ''
                  }
                  onDone={() => setWindexOpen(false)}
                  onCancel={() => setWindexOpen(false)}
                />
              ) : null}

              <div
                className={`mt-8 flex items-center justify-between ${
                  isWindex && windexOpen ? 'hidden' : ''
                }`}
              >
                {app.installed && connectedDetail ? (
                  <div className="flex items-center border border-gray-200 rounded-lg px-3 py-1.5 bg-gray-50/50 max-w-[150px] overflow-hidden">
                    <span
                      className="text-[13px] font-semibold text-gray-700 truncate w-full"
                      title={connectedDetail}
                    >
                      {connectedDetail}
                    </span>
                  </div>
                ) : (
                  <div />
                )}
                {app.installed ? (
                  isUnhealthy ? (
                    <button
                      onClick={selectApp}
                      className="bg-rose-600 hover:bg-rose-700 text-white text-sm font-semibold px-4 py-2 rounded-lg flex items-center gap-2 transition-colors shadow-sm"
                    >
                      <svg
                        className="w-4 h-4"
                        viewBox="0 0 24 24"
                        fill="none"
                        stroke="currentColor"
                        strokeWidth="2.5"
                      >
                        <path
                          strokeLinecap="round"
                          strokeLinejoin="round"
                          d="M4 4v5h.582m15.356 2A8.001 8.001 0 004.582 9m0 0H9m11 11v-5h-.581m0 0a8.003 8.003 0 01-15.357-2m15.357 2H15"
                        />
                      </svg>
                      Reconnect
                    </button>
                  ) : (
                    <button
                      onClick={selectApp}
                      className="bg-[#4CAF50] hover:bg-[#45a049] text-white text-sm font-semibold px-4 py-2 rounded-lg flex items-center gap-2 transition-colors shadow-sm"
                    >
                      <svg
                        className="w-4 h-4"
                        viewBox="0 0 24 24"
                        fill="none"
                        stroke="currentColor"
                        strokeWidth="2.5"
                      >
                        <path
                          strokeLinecap="round"
                          strokeLinejoin="round"
                          d="M8 7h12m0 0l-4-4m4 4l-4 4m0 6H4m0 0l4 4m-4-4l4-4"
                        />
                      </svg>
                      Configure
                    </button>
                  )
                ) : (
                  <>
                    <div></div>
                    {isInstagram ? (
                      <button
                        onClick={() => onConnectInstagram?.(app)}
                        className="bg-[#4CAF50] hover:bg-[#45a049] text-white text-sm font-semibold px-4 py-2 rounded-lg flex items-center gap-2 transition-colors shadow-sm"
                      >
                        <svg
                          className="w-4 h-4"
                          viewBox="0 0 24 24"
                          fill="none"
                          stroke="currentColor"
                          strokeWidth="2.5"
                        >
                          <path
                            strokeLinecap="round"
                            strokeLinejoin="round"
                            d="M13.828 10.172a4 4 0 00-5.656 0l-4 4a4 4 0 105.656 5.656l1.102-1.101m-.758-4.899a4 4 0 005.656 0l4-4a4 4 0 00-5.656-5.656l-1.1 1.1"
                          />
                        </svg>
                        Connect
                      </button>
                    ) : isWhatsApp ||
                      isGoogleWorkspace ||
                      isOtherEmail ||
                      isWindex ? (
                      <button
                        onClick={selectApp}
                        className="bg-[#4CAF50] hover:bg-[#45a049] text-white text-sm font-semibold px-4 py-2 rounded-lg flex items-center gap-2 transition-colors shadow-sm"
                      >
                        <svg
                          className="w-4 h-4"
                          viewBox="0 0 24 24"
                          fill="none"
                          stroke="currentColor"
                          strokeWidth="2.5"
                        >
                          <path
                            strokeLinecap="round"
                            strokeLinejoin="round"
                            d="M13.828 10.172a4 4 0 00-5.656 0l-4 4a4 4 0 105.656 5.656l1.102-1.101m-.758-4.899a4 4 0 005.656 0l4-4a4 4 0 00-5.656-5.656l-1.1 1.1"
                          />
                        </svg>
                        Connect
                      </button>
                    ) : null}
                  </>
                )}
              </div>
            </div>
          );
        })}
      </div>
      <ComingSoonIntegrations />
    </div>
  );
}

function ComingSoonIntegrations() {
  const apps = INTEGRATIONS_CATALOG.messengers.filter(
    (app) => app.id === 'facebook' || app.id === 'threads',
  );
  return (
    <section className="rounded-2xl border border-dashed border-[#C5D0E6] bg-[#F7F9FC] p-4 sm:p-5">
      <h2 className="text-sm font-semibold text-[#5B6B82] mb-4">Coming soon</h2>
      <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-4">
        {apps.map((app) => (
          <div
            key={app.id}
            className="rounded-2xl border border-[#E3E8F0] bg-white/70 p-5 opacity-80"
          >
            <div className="flex justify-between items-start mb-4">
              <IntegrationLogo type={app.logoType} size="h-11 w-11" />
              <span className="flex items-center gap-1.5 px-2.5 py-1 rounded-full text-[10px] font-bold tracking-wide bg-[#EEF2F7] text-[#6B7C93]">
                <span className="w-1.5 h-1.5 rounded-full bg-[#8AA0B8]" />
                Coming soon
              </span>
            </div>
            <h3 className="text-[17px] font-semibold text-[#5C6B80] mb-2">
              {app.name}
            </h3>
            <p className="text-[13px] text-[#8A97A8] leading-relaxed font-medium">
              {app.description}
            </p>
          </div>
        ))}
      </div>
    </section>
  );
}
